import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

// Setting for prodiction
axios.defaults.baseURL = location.protocol + '//' + location.hostname + '/api'
// Setting in .env file for dev
// axios.defaults.baseURL = process.env.VUE_APP_ROOT_API

export default new Vuex.Store({
    state: {
        referral_data: {
            parent_id: 'default_id',
            parent_fio: 'default_fio',
        },
    },
    mutations: {
        setParentPersonData(state, data) {
            state.referral_data.parent_id = data.person_id
            state.referral_data.parent_fio = data.person_fio
        },
        setSettings(state, settingsData) {
            state.settings = settingsData.settings[0]
        },
        setPhone(state, data) {
            state.referral_data.phone = data.phone
        },
		setReferral(state, data) {
            state.referral_data.person_firstname = data.innerData.person_firstname;
            state.referral_data.person_lastname = data.innerData.person_lastname;
            state.referral_data.person_midname = data.innerData.person_midname;
            state.referral_data.card_number = data.responseData.card_number;
        },
    },
    actions: {
        getParentPerson({commit}, credentials) {
            return axios
                .post('/getparentperson', credentials)
                .then(({data}) => {
                    commit('setParentPersonData', data)
                })
        },
        getSettings({commit}) {
            return axios
                .post('/getsettingspublic')
                .then(({data}) => {
                    commit('setSettings', data)
                })
        },
        sendVerification({commit}, credentials) {
            return axios
                .post('/send_verification', credentials)
                .then(() => {
                    commit('setPhone', credentials);
                })
        },
        submitRegistration({commit}, credentials) {
            return axios
                .post('/registration', credentials)
                .then(({data}) => {
                    commit('setReferral', {innerData: credentials, responseData: data});
                })
        }
    },
    getters: {
        PARENT_PERSON: state => {
            return state.referral_data;
        },
        SETTINGS: state => {
            return state.settings;
        },
    },
    modules: {}
})
